import { Location } from '@core/interfaces';

export interface DialogEquipmentServiceOpen {
  equipmentId?: string;
  selectedTab?: DialogEquipmentTabsEnum;
  location?: Location;
  disableEditLocation?: boolean;
}

export interface DialogEquipmentServiceGet {
  equipmentId?: string;
  location?: Location;
}

export enum DialogEquipmentTabsEnum {
  GENERAL = 0,
  WARRANTIES = 1,
  CUSTOM_FIELDS = 2,
  ATTACHMENTS = 3,
  HISTORY = 4,
  MAINTENANCES = 5,
}
